
import JSEncrypt from 'jsencrypt/bin/jsencrypt'
// json转formData
export function jsonToFormData(json, parentKey = '', carrier) {
  const formData = carrier || new FormData()
  Object.keys(json).forEach((key) => {
    if (json[key] instanceof Array) {
      jsonToFormData(json[key], (parentKey ? parentKey + '.' : '') + ((json instanceof Array) ? `[${key}]` : key), formData)
    } else if (json[key] instanceof Object && !(json[key] instanceof Blob)) {
      jsonToFormData(json[key], parentKey + ((json instanceof Array) ? `[${key}]` : ((json instanceof Object) && !(json[key] instanceof Blob) && parentKey ? `.${key}` : key)), formData)
    } else {
      formData.append(json instanceof Array ? `${parentKey}[${key}]` : `${parentKey ? parentKey + '.' : ''}${key}`, json[key])
    }
  })
  return formData
}

// 密钥对生成 http://web.chacuo.net/netrsakeypair

const publicKey = 'MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBANL378k3RiZHWx5AfJqdH9xRNBmD9wGD\n' +
  '2iRe41HdTNF8RUhNnHit5NpMNtGL0NPTSSpPjjI1kJfVorRvaQerUgkCAwEAAQ=='

const privateKey = 'MIIBUwIBADANBgkqhkiG9w0BAQEFAASCAT0wggE5AgEAAkEA0vfvyTdGJkdbHkB8\n' +
  'mp0f3FE0GYP3AYPaJF7jUd1M0XxFSE2ceK3k2kw20YvQ09NJKk+OMjWQl9WitG9p\n' +
  'B6tSCQIDAQABAkA2SimBrWC2/wvauBuYqjCFwLvYiRYqZKThUS3MZlebXJiLB+Ue\n' +
  '/gUifAAKIg1avttUZsHBHrop4qfJCwAI0+YRAiEA+W3NK/RaXtnRqmoUUkb59zsZ\n' +
  'UBLpvZgQPfj1MhyHDz0CIQDYhsAhPJ3mgS64NbUZmGWuuNKp5coY2GIj/zYDMJp6\n' +
  'vQIgUueLFXv/eZ1ekgz2Oi67MNCk5jeTF2BurZqNLR3MSmUCIFT3Q6uHMtsB9Eha\n' +
  '4u7hS31tj1UWE+D+ADzp59MGnoftAiBeHT7gDMuqeJHPL4b+kC+gzV4FGTfhR9q3\n' +
  'tTbklZkD2A=='

// 加密
export function encrypt(txt) {
  const encryptor = new JSEncrypt()
  encryptor.setPublicKey(publicKey) // 设置公钥
  return encryptor.encrypt(txt) // 对需要加密的数据进行加密
}

// 解密
export function decrypt(txt) {
  const encryptor = new JSEncrypt()
  encryptor.setPrivateKey(privateKey)
  return encryptor.decrypt(txt)
}
// 验证是否是域名
export function checkdomain() {
  // eslint-disable-next-line no-useless-escape
  const reg = /^(?=^.{3,255}$)(http(s)?:\/\/)?(www\.)?[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z][-a-zA-Z]{0,62})+(:\d+)*([\/]|(\/\w+))*$/
  // console.log("d.h: " + document.domain)
  // let url = document.URL.split("://")[1];
  // let hp = url.split("/")[0];
  // console.log("d.h:--- " + hp)
  // const allowed_domain = ['tsdr.dongxinsoft.cn:8088', 'uat.tsdrxny.com:8088', 'prod.tsdrxny.com:8088']
  return reg.test(document.domain)
}
/**
 * 浮点数加法运算 arg1+arg2
 * @param {number} arg1
 * @param {number} arg2
 * @return {number}
 */
export function FloatAdd(arg1, arg2) {
  let r1, r2
  try {
    r1 = arg1 && arg1.toString().split('.')[1].length
  } catch (e) {
    r1 = 0
  }
  try {
    r2 = arg2 && arg2.toString().split('.')[1].length
  } catch (e) {
    r2 = 0
  }
  const m = Math.pow(10, Math.max(r1, r2))
  return FloatDiv((FloatMul(arg1 && arg1, m) + FloatMul(arg2 && arg2, m)), m)
}

/**
 * 浮点数减法运算 arg1-arg2
 * @param {number} arg1
 * @param {number} arg2
 * @return {number}
 */
export function FloatSub(arg1, arg2) {
  let r1, r2
  try {
    r1 = arg1 && arg1.toString().split('.')[1].length
  } catch (e) {
    r1 = 0
  }
  try {
    r2 = arg2 && arg2.toString().split('.')[1].length
  } catch (e) {
    r2 = 0
  }
  const m = Math.pow(10, Math.max(r1, r2))
  // 动态控制精度长度
  const n = (r1 >= r2) ? r1 : r2
  return (FloatDiv((FloatMul(arg1 && arg1, m) - FloatMul(arg2 && arg2, m)), m))// .toFixed(n)
}

/**
 * 浮点数乘法运算 arg1*arg2
 * @param {number} arg1
 * @param {number} arg2
 * @return {number}
 */
export function FloatMul(arg1, arg2, n) {
  let m = 0
  const s1 = arg1 && arg1.toString()
  const s2 = arg2 && arg2.toString()
  try {
    m += s1 && s1.split('.')[1].length
  } catch (e) {
  }
  try {
    m += s2 && s2.split('.')[1].length
  } catch (e) {
  }
  return (Number(s1 && s1.replace('.', '')) * Number(s2 && s2.replace('.', '')) / Math.pow(10, m)).toFixed(n)
}

/**
 * 浮点数除法运算 arg1/arg2
 * @param {number} arg1
 * @param {number} arg2
 * @return {number}
 */
export function FloatDiv(arg1, arg2, n) {
  let t1 = 0; let t2 = 0
  try {
    t1 = arg1 && arg1.toString().split('.')[1].length
  } catch (e) {
  }
  try {
    t2 = arg2 && arg2.toString().split('.')[1].length
  } catch (e) {
  }
  const r1 = Number(arg1 && arg1.toString().replace('.', ''))
  const r2 = Number(arg2 && arg2.toString().replace('.', ''))
  return (r1 / r2) * Math.pow(10, t2 - t1).toFixed(n)
}
